(function () {
    "use strict";

    angular.module("app").component("installationView", {
        templateUrl: "@/installation/installation-view.html",
        bindings: {
            installation: "="
        },
        controller: ViewController
    });


    ViewController.$inject = ["$rootScope"];
    function ViewController($rootScope) {
        const vm = this;
        
        vm.Levels = $rootScope.codeFVMVILevels;
        vm.AttachmentTypes = $rootScope.codeAttachmentTypes;
        vm.FVMTypeCodes = $rootScope.codeVMTypes;
        vm.FVMLevels = $rootScope.codeFVMLevels;
    }
})();